import { withRBAC } from "../rbac";
import { BoMCreate } from "./BoMCreate";
import { BoMEdit } from "./BoMEdit";
import { BoMList } from "./BoMList";
import { BoMShow } from "./BoMShow";

export const boms = {
    list: withRBAC(BoMList, "view_production"),
    show: withRBAC(BoMShow, "view_production"),
    create: withRBAC(BoMCreate, "manage_production"),
    edit: withRBAC(BoMEdit, "manage_production"),
    recordRepresentation: 'reference'
};
